/**
 * Utilities for persisting list view state during navigation
 */

const LIST_STATE_KEY = 'zapt_list_state';

export const listState = {
  /**
   * Save the current list state before navigating to request details
   */
  save(state) {
    try {
      const stateToSave = {
        searchQuery: state.searchQuery || '',
        sortBy: state.sortBy || 'newest',
        filterBy: state.filterBy || 'all',
        scrollPosition: window.scrollY,
        timestamp: Date.now()
      };
      sessionStorage.setItem(LIST_STATE_KEY, JSON.stringify(stateToSave));
      console.log('List state saved:', stateToSave);
    } catch (error) {
      console.error('Failed to save list state:', error);
    }
  },

  /**
   * Restore list state after returning from request details
   */
  restore() {
    try {
      const saved = sessionStorage.getItem(LIST_STATE_KEY);
      if (!saved) return null;

      const state = JSON.parse(saved);
      
      // Check if state is recent (within 30 minutes)
      const isRecent = Date.now() - state.timestamp < 30 * 60 * 1000;
      if (!isRecent) {
        this.clear();
        return null;
      }

      console.log('List state restored:', state);
      return state;
    } catch (error) {
      console.error('Failed to restore list state:', error);
      this.clear();
      return null;
    }
  },

  /**
   * Clear saved list state
   */
  clear() {
    try {
      sessionStorage.removeItem(LIST_STATE_KEY);
      console.log('List state cleared');
    } catch (error) {
      console.error('Failed to clear list state:', error);
    }
  }
}; 